module.exports = __webpack_public_path__ + "img/categorie_guinguette.461e41b.jpg";